module.exports = __webpack_public_path__ + "img/partner_logo2.1a3fac58.png";